import React from 'react';
import { PageHeader, Icon } from '@salesforce/design-system-react';
import MetaMaskDetails from './details';

const MetaMask = () => {
  return (
    <>
      <div>
        <PageHeader
          icon={
            <Icon
              assistiveText={{ label: 'MetaMask' }}
              category="standard"
              name="catalog"
              containerStyle={{
                backgroundColor: '#48C3CC',
              }}
            />
          }
          label="MetaMask"
          title="MetaMask"
          variant="record-home"
        />
      </div>
      <MetaMaskDetails />
    </>
  );
};

export default MetaMask;
